import React, { useCallback, useMemo } from 'react';
import {
  Employee as EmployeeModel,
  EmployeeRole,
  RolesNamesBE,
} from '../../models/employee';
import { AppCard } from '../app/appCard';

interface Props {
  employee: EmployeeModel;
  handleRoles(employee: EmployeeModel): void;
  handleDetails(employee: EmployeeModel): void;
  handleDelete(employee: EmployeeModel): void;
  permissions?: EmployeeRole[];
}

export function Employee({
  employee,
  handleRoles,
  handleDetails,
  permissions,
}: Props): JSX.Element {
  const handleManage = useCallback(() => {
    handleRoles(employee);
  }, [handleRoles, employee]);

  const handleView = useCallback(() => {
    handleDetails(employee);
  }, [handleDetails, employee]);

  const buttons = useMemo(() => {
    const defaultAction = [
      {
        label: 'View',
        onClick: handleView,
        isPrimary: false,
      },
    ];
    if (
      permissions &&
      permissions.some((el) => el.name === RolesNamesBE.ADMIN)
    ) {
      defaultAction.push({
        label: 'Roles',
        onClick: handleManage,
        isPrimary: true,
      });
    }

    return defaultAction;
  }, [handleManage, handleView, permissions]);

  return (
    <AppCard
      title={`${employee.name}`}
      statusInfo={employee.isActive}
      details={[employee.jobTitle, employee.department, employee.email]}
      buttons={buttons}
    />
  );
}
